if (!customElements.get('product-form-component')) {
  customElements.define(
    'product-form-component',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        
        // FIX: Gunakan private property _variantIdInput
        this._variantIdInput = this.form.querySelector('[name="id"]');
        if (this._variantIdInput) {
          this._variantIdInput.disabled = false;
        }
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.form?.querySelector('[type="submit"], .add-to-cart-button');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
        this.buyItNowButton = this.form?.querySelector('.shopify-payment-button');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initAgreeCondition();
        this.initVariantEvents();
        this.setupErrorSync();
      }

      initVariantEvents() {
        const optionSelectors = this.querySelectorAll('.variant-option-input, select[name^="options"], input[name^="options"]');
        
        optionSelectors.forEach(selector => {
          selector.addEventListener('change', () => this.onVariantChange());
        });

        // Initial dispatch
        setTimeout(() => this.onVariantChange(), 100);
      }

      onVariantChange() {
        try {
          const variant = this.getSelectedVariant();
          
          if (variant && this._variantIdInput) {
            this._variantIdInput.value = variant.id;
            
            // Dispatch variant:change event
            this.form.dispatchEvent(new CustomEvent('variant:change', {
              detail: { variant },
              bubbles: true
            }));
            
            document.dispatchEvent(new CustomEvent('variant:change', {
              detail: { variant },
              bubbles: true
            }));
            
            console.log('✅ Variant changed:', variant.id, variant.price);
          }
        } catch (e) {
          console.error('⚠️ Variant change error (ignored):', e);
        }
      }

      getSelectedVariant() {
        const options = [];
        
        // Collect from SELECT elements
        this.form.querySelectorAll('select[name^="options"]').forEach(select => {
          if (select.value) options.push(select.value);
        });
        
        // Collect from RADIO elements (checked only)
        this.form.querySelectorAll('input[type="radio"][name^="options"]:checked').forEach(radio => {
          if (radio.value) options.push(radio.value);
        });

        // Get variants data
        let variants = [];
        try {
          if (this.dataset.variants) {
            variants = JSON.parse(this.dataset.variants);
          } else {
            // Fallback: cari dari script JSON di page
            const variantJson = document.querySelector('[data-variant-json], script[type="application/json"]');
            if (variantJson) variants = JSON.parse(variantJson.textContent);
          }
        } catch (e) {
          console.error('Variants JSON parse error:', e);
          return null;
        }

        // Match variant
        return variants.find(v => 
          String(v.option1 || '') === String(options[0] || '') &&
          String(v.option2 || '') === String(options[1] || '') &&
          String(v.option3 || '') === String(options[2] || '')
        ) || null;
      }

      setupErrorSync() {
        try {
          const productInfo = this.closest('product-info');
          const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
          if (!sectionId) return;

          const stickyATC = document.querySelector(`sticky-atc[data-sticky-section-id="${sectionId}"]`);
          if (!stickyATC) return;

          const mainErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const stickyErrorWrapper = stickyATC.querySelector('.product-form__error-message-wrapper');
          if (!mainErrorWrapper || !stickyErrorWrapper) return;

          const syncFromMain = () => {
            const isVisible = !mainErrorWrapper.hasAttribute('hidden');
            const errorMessage = mainErrorWrapper.querySelector('.product-form__error-message')?.textContent;
            stickyErrorWrapper.toggleAttribute('hidden', !isVisible || !errorMessage);
            if (isVisible && errorMessage) {
              const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
              if (stickyErrorMessage) stickyErrorMessage.textContent = errorMessage;
            }
          };

          syncFromMain();
          this._errorObserver = new MutationObserver(syncFromMain);
          this._errorObserver.observe(mainErrorWrapper, {
            attributes: true,
            attributeFilter: ['hidden'],
            childList: true,
            subtree: true
          });

          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartError) {
            this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => {
              syncFromMain();
            });
          }
        } catch (e) {}
      }

      initAgreeCondition() {
        if (!this.checkbox || !this.buyItNowButton) return;
        this.buyItNowButton.classList.add('disabled');

        this.checkbox.addEventListener('change', () => {
          this.buyItNowButton.classList.toggle('disabled', !this.checkbox.checked);
        });

        this.form.addEventListener('submit', (e) => {
          if (!this.checkbox.checked) {
            e.preventDefault();
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');
        this.submitButton?.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const properties = this.form.querySelectorAll('[name^="properties"]');
        properties.forEach(property => {
          if (property.type === 'file') {
            if (property.files[0]) formData.append(property.name, property.files[0]);
          } else if (property.value) {
            formData.append(property.name, property.value);
          }
        });

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form-component',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.handleErrorMessage(response.description || response.message);
              return;
            }
            
            if (!this.cart) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form-component',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            if (this.cart?.renderContents) this.cart.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton?.classList.remove('loading');
            this.submitButton?.removeAttribute('aria-disabled');
            this.submitButton?.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      disconnectedCallback() {
        try {
          this.cartErrorUnsubscriber?.();
          this._errorObserver?.disconnect();
        } catch (e) {}
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}
